import { render } from "./OrdersPayment.vue?vue&type=template&id=52a5aa0c"
import script from "./OrdersPayment.vue?vue&type=script&lang=js"
export * from "./OrdersPayment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__